import React from 'react';
import { Info, Shield, Share2, Lock, Scale, RefreshCw, Mail } from 'lucide-react';
import '../../../../styles/components/privacy-policy.scss';
import HeaderBanner from '../../../common/HeaderBanner';
import i18n from '../../../../i18n';

class TermsOfServicePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSection: 'information-we-collect',
      activeNav: 'Contact',
    };
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleSectionClick = (sectionId) => {
    this.setState({ activeSection: sectionId });
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  render() {
    const { activeSection } = this.state;

    const menuItems = [
      { id: 'information-we-collect', label: i18n.t('information_we_collect'), icon: Info },
      { id: 'how-we-use', label: i18n.t('how_we_use'), icon: Shield },
      { id: 'data-sharing', label: i18n.t('data_sharing'), icon: Share2 },
      { id: 'data-security', label: i18n.t('data_security'), icon: Lock },
      { id: 'your-rights', label: i18n.t('your_rights'), icon: Scale },
      { id: 'changes-policy', label: i18n.t('changes'), icon: RefreshCw },
      { id: 'contact-us', label: i18n.t('contact_us'), icon: Mail },
    ];

    return (
      <div className="privacy-page">
        <HeaderBanner
          title={i18n.t('terms_of_service')}
          subtitle={i18n.t('terms_of_service_subtitle')}
        />

        <div className="privacy-container">
          <aside className="privacy-sidebar">
            <nav>
              {menuItems.map((item) => {
                const Icon = item.icon;
                const isActive = activeSection === item.id;
                return (
                  <button
                    key={item.id}
                    onClick={() => this.handleSectionClick(item.id)}
                    className={`sidebar-item ${isActive ? 'active' : ''}`}
                  >
                    <Icon size={20} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </aside>

          <main className="privacy-content">
            <div className="update-date">{i18n.t('last_updated')}: October 26, 2023</div>

            <div className="intro-text">
              {i18n.t('welcome_message')}
            </div>

            <section id="information-we-collect" className="privacy-section">
              <h2>{i18n.t('section_1')}</h2>
              <p>{i18n.t('section_1_text')}</p>
              <h3>{i18n.t('personal_data')}</h3>
              <p>{i18n.t('personal_data_desc')}</p>
              <h3>{i18n.t('derivative_data')}</h3>
              <p>{i18n.t('derivative_data_desc')}</p>
            </section>

            <section id="how-we-use" className="privacy-section">
              <h2>{i18n.t('section_2')}</h2>
              <ul>
                <li>{i18n.t('use_create_account')}</li>
                <li>{i18n.t('use_email')}</li>
                <li>{i18n.t('use_fulfill')}</li>
                <li>{i18n.t('use_improve')}</li>
              </ul>
            </section>

            <section id="data-sharing" className="privacy-section">
              <h2>{i18n.t('section_3')}</h2>
              <h3>{i18n.t('sharing_by_law')}</h3>
              <p>
                {i18n.t('sharing_by_law_desc')}
              </p>
            </section>

            <section id="data-security" className="privacy-section">
              <h2>{i18n.t('section_4')}</h2>
              <p>{i18n.t('data_security_desc')}</p>
            </section>

            <section id="your-rights" className="privacy-section">
              <h2>{i18n.t('section_5')}</h2>
              <p>{i18n.t('rights_desc')}</p>
            </section>

            <section id="changes-policy" className="privacy-section">
              <h2>{i18n.t('section_6')}</h2>
              <p>{i18n.t('changes_desc')}</p>
            </section>

            <section id="contact-us" className="privacy-section">
              <h2>{i18n.t('section_7')}</h2>
              <div className="contact-box">
                <p><strong>{i18n.t('group_auction')}</strong></p>
                <p>{i18n.t('office_address_info')}</p>
                <p>Email: info@mzadcom.om</p>
              </div>
            </section>
          </main>
        </div>
      </div>
    );
  }
}

export default TermsOfServicePage;